module.exports = __webpack_public_path__ + "img/3.ee20229c.png";